import { action, actionOn, thunk } from 'easy-peasy';
import services from 'services';
import refused from 'store/admin/returns/refused';

export default {
	wishlists: [],
	approved: [],
	refused: [],
	filters: {
		token: '',
		depots: [],
		types: []
	},
	loadingWishlists: false,
	setLoadingWishlists: action((state, payload) => {
		state.loadingWishlists = payload;
	}),
	loadingWishlistDetail: false,
	setLoadingWishlistDetail: action((state, payload) => {
		state.loadingWishlistDetail = payload;
	}),
	loadingAction: false,
	setLoadingAction: action((state, payload) => {
		state.loadingAction = payload;
	}),
	expanded: { index: -1, id: -1 },
	setExpanded: action((state, payload) => {
		state.expanded = payload;
	}),
	expandedApproved: { index: -1, id: -1 },
	setExpandedApproved: action((state, payload) => {
		state.expandedApproved = payload;
	}),
	expandedRefused: { index: -1, id: -1 },
	setExpandedRefused: action((state, payload) => {
		state.expandedRefused = payload;
	}),
	tabSelected: 0,
	setTabSelected: action((state, payload) => {
		state.tabSelected = payload;
	}),
	saveWishlists: action((state, payload) => {
		state.wishlists = payload;
	}),
	saveApproved: action((state, payload) => {
		state.approved = payload;
	}),
	saveRefused: action((state, payload) => {
		state.refused = payload;
	}),
	openUpdateQta: false,
	setOpenUpdateQta: action((state, payload) => {
		state.openUpdateQta = payload;
	}),
	setToken: action((state, payload) => {
		state.filters.token = payload.toUpperCase();
	}),
	selectDepotsValue: [],
	setSelectDepotsValue: action((state, payload) => {
		state.selectDepotsValue = payload;
	}),
	toggleDepot: action((state, payload) => {
		const i = state.filters.depots.findIndex(item => item === payload);
		if (i === -1) state.filters.depots.push(payload);
		else state.filters.depots.splice(i, 1);
	}),
	selectTypesValue: [],
	setSelectTypesValue: action((state, payload) => {
		state.selectTypesValue = payload;
	}),
	toggleType: action((state, payload) => {
		const i = state.filters.types.findIndex(item => item === payload);
		if (i === -1) state.filters.types.push(payload);
		else state.filters.types.splice(i, 1);
	}),
	wishlistDetail: [],
	saveWishlistDetail: action((state, payload) => {
		state.wishlistDetail = payload.wishlistItems.map(item => ({
			...item.catalog,
			id: item.id,
			fullPrice: item.fullPrice,
			quantity: item.quantity,
			depotDescription: item.depotDescription,
			selected: false
		}));
	}),
	allSelection: action((state, payload) => {
		state.wishlistDetail = state.wishlistDetail.map(item => ({
			...item,
			selected: payload
		}));
	}),
	orderBy: 'title',
	orderDirection: 'asc',
	setOrder: action((state, payload) => {
		if (state.orderBy === payload) {
			state.orderDirection = state.orderDirection === 'asc' ? 'desc' : 'asc';
		} else {
			state.orderDirection = 'asc';
		}
		state.orderBy = payload;
	}),
	loadPending: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingWishlists(true);
		services.wishlistSpecial
			.getPending()
			.then(data => {
				actions.saveWishlists(data.items);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.loadWishlists');
			})
			.finally(_ => {
				actions.setLoadingWishlists(false);
			});
	}),
	loadApproved: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingWishlists(true);
		services.wishlistSpecial
			.getApproved()
			.then(data => {
				actions.saveApproved(data.items);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.loadWishlists');
			})
			.finally(_ => {
				actions.setLoadingWishlists(false);
			});
	}),
	loadRefused: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingWishlists(true);
		services.wishlistSpecial
			.getRefused()
			.then(data => {
				actions.saveRefused(data.items);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.loadWishlists');
			})
			.finally(_ => {
				actions.setLoadingWishlists(false);
			});
	}),
	loadWishlistDetail: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingWishlistDetail(true);
		services.conditionRequest
			.getDetailsSpecial(payload)
			.then(data => {
				actions.saveWishlistDetail(data.item);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.loadWishlistIDetail');
			})
			.finally(_ => {
				actions.setLoadingWishlistDetail(false);
			});
	}),
	reject: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingAction(true);
		services.wishlistSpecial
			.reject(payload)
			.then(data => {
				getStoreActions().success('wishlistSpecial.reject');
				actions.setExpanded(-1);
				actions.loadPending();
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.reject');
			})
			.finally(_ => {
				actions.setLoadingAction(false);
			});
	}),
	accept: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		actions.setLoadingAction(true);
		services.wishlistSpecial
			.accept(payload)
			.then(data => {
				getStoreActions().success('wishlistSpecial.accept');
				actions.setExpanded(-1);
				actions.loadPending();
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.accept');
			})
			.finally(_ => {
				actions.setLoadingAction(false);
			});
	}),
	removeItem: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		actions.setLoadingAction(true);
		services.wishlistSpecial
			.removeItem(payload)
			.then(data => {
				actions.updateOnRemoveItem(data);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.action');
			})
			.finally(_ => {
				actions.setLoadingAction(false);
			});
	}),
	updateOnRemoveItem: action((state, payload) => {
		state.wishlists = state.wishlists.map(item => ({
			...item,
			totalItems: item.id === payload.idWishlist ? payload.totalItems : item.totalItems,
			totalPrice: item.id === payload.idWishlist ? payload.totalPrice : item.totalPrice
		}));
		state.wishlistDetail = state.wishlistDetail.filter(item => item.id !== payload.id);
	}),
	updateItem: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		actions.setLoadingAction(true);
		services.wishlistSpecial
			.updateItem(payload)
			.then(data => {
				actions.setOpenUpdateQta(false);
				actions.loadPending();
				actions.loadWishlistDetail(getStoreState().wishlistSpecial.expanded.id);
			})
			.catch(e => {
				getStoreActions().error('wishlistSpecial.action');
			})
			.finally(_ => {
				actions.setLoadingAction(false);
			});
	})
};
